import { render, staticRenderFns } from "./DistributeAccountSL.vue?vue&type=template&id=63b84704&scoped=true&"
import script from "./DistributeAccountSL.vue?vue&type=script&lang=js&"
export * from "./DistributeAccountSL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b84704",
  null
  
)

export default component.exports